import React, { useEffect, useState } from "react";
import SidebarHeaderLayout from "../../HOC/SidebarHeaderLayout";
import { createLostAndFound, getAllGuestlist } from "../../../api-core/Ghms";
import { useFormik } from "formik";
import * as Yup from "yup";
const CreateLostAndFound = () => {
  const [guestIdData, setGuestIdData] = useState([]);
  const [guestNameData, setGuestNameData] = useState([]);
  const [loading, setloading] = useState(false);
  const initialValues = {
    sub_event_id: "",
    guest_id: "",
    item_name: "",
    item_identification: "",
    lost_place: "",
    found_place: "",
    found_by: "",
    deliver_type: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      sub_event_id: Yup.string().required("Sub event name is required"),
      guest_id: Yup.string().required("guest name is required"),
      item_name: Yup.string().required("item is required"),
      item_identification: Yup.string().required(
        "item identification is required"
      ),
      lost_place: Yup.string().required("lost place is required"),
      found_place: Yup.string().required("found place is required"),
      found_by: Yup.string().required("found by is required"),
      deliver_type: Yup.string().required("delivery type is required"),
    }),
    onSubmit: async (values, action) => {
      console.log("values", values);

      if (values) {
        const res = await createLostAndFound(values);
        console.log("resFormData", res);
        action.resetForm();
      } else {
        console.log("error");
      }
    },
  });

  useEffect(() => {
    const fetchAllGuestList = async () => {
      setloading(true);
      const res = await getAllGuestlist();
      console.log("res", res.ghmsguestlist);

      setGuestIdData(res.ghmsguestlist);
      setloading(false);
    };
    fetchAllGuestList();
  }, []);

  return (
    <div className="w-[90%] mx-auto ">
      <h1>Create Lost And Found</h1>
      <form onSubmit={formik.handleSubmit} encType="multipart/form-data">
        <div className="flex flex-col justify-center items-center  md:justify-between md:flex-row gap-x-5 flex-wrap">
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Sub Event Title
            </label>
            <select
              value={formik.values.sub_event_id}
              name="sub_event_id"
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="">select an option</option>
              {guestIdData.map((value) => (
                <option value={value.sub_event_id._id} key={value._id}>
                  {value.sub_event_id.subevent_title}
                </option>
              ))}
            </select>
            {formik.errors.sub_event_id && (
              <span className="text-red-500">{formik.errors.sub_event_id}</span>
            )}
          </div>

          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Guset Name
            </label>
            <select
              value={formik.values.guest_id}
              name="guest_id"
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="">select an option</option>
              {guestIdData.map((value) => (
                <option value={value._id} key={value._id}>
                  {value.guest_name}
                </option>
              ))}
            </select>
            {formik.errors.guest_id && (
              <span className="text-red-500">{formik.errors.guest_id}</span>
            )}
          </div>
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Item Name
            </label>
            <input
              type="text"
              name="item_name"
              value={formik.values.item_name}
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="enter item name"
            />
            {formik.errors.item_name && (
              <span className="text-red-500">{formik.errors.item_name}</span>
            )}
          </div>
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Item Identification
            </label>
            <input
              type="text"
              name="item_identification"
              value={formik.values.item_identification}
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="enter item identification"
            />
            {formik.errors.item_identification && (
              <span className="text-red-500">{formik.errors.item_identification}</span>
            )}
          </div>
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Lost Place
            </label>
            <input
              type="text"
              name="lost_place"
              value={formik.values.lost_place}
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="enter lost place"
            />
            {formik.errors.lost_place && (
              <span className="text-red-500">{formik.errors.lost_place}</span>
            )}
          </div>
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Found Place
            </label>
            <input
              type="text"
              name="found_place"
              value={formik.values.found_place}
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="enter found Place"
            />
            {formik.errors.found_place && (
              <span className="text-red-500">{formik.errors.found_place}</span>
            )}
          </div>
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Found By
            </label>
            <input
              type="text"
              name="found_by"
              value={formik.values.found_by}
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="enter  found by"
            />
            {formik.errors.found_by && (
              <span className="text-red-500">{formik.errors.found_by}</span>
            )}
          </div>
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Devliver Type
            </label>
            <input
              type="text"
              name="deliver_type"
              value={formik.values.deliver_type}
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="enter deliver type"
            />
            {formik.errors.deliver_type && (
              <span className="text-red-500">{formik.errors.deliver_type}</span>
            )}
          </div>
        </div>
        <button
          type="submit"
          className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-[50%] sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default SidebarHeaderLayout(CreateLostAndFound);
